import React, { Component } from "react";
import ProvinciaDetalle from "../provincia/provincia_detalle";

export default class DireccionGeneral extends Component {
  render() {
    return (
      <React.Fragment>
        <ProvinciaDetalle {...this.props} ruta="DireccionGeneral"></ProvinciaDetalle>
      </React.Fragment>
    );
  }
}
